module.exports = __webpack_public_path__ + "img/logo-buu.jpg";